import { BaseApi } from '@/api/BaseApi';

const FILE_URL_PREFIX = '/api/file';

export type GetFileUploadResponseBody = {
  access_url: string;
  upload_url: string;
};

export class FileApi extends BaseApi {
  async uploadFile(threadId: string, file: File) {
    // Retrieve pre-signed URL for file upload to file host.
    // TODO error response?
    const { data: urls } = await this.request<GetFileUploadResponseBody>({
      url: `${FILE_URL_PREFIX}/upload`,
      method: 'GET',
      query: {
        thread_id: threadId,
        filename: file.name,
        content_type: file.type,
      },
    });
    // Actually upload the file to the file host.
    // TODO error response?
    await fetch(urls.upload_url, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type,
      },
    });
    return urls.access_url;
  }
}

let fileApi: FileApi | undefined;
export function getFileAPI(): FileApi {
  if (!fileApi) {
    fileApi = new FileApi();
  }
  return fileApi;
}
